import weatherStore from '../store';
import { OwaDate, differenceInCalendarDays } from 'owa-datetime';
import { observableToday } from 'owa-observable-datetime';

export function isWeatherAvailableForDate(date: OwaDate): boolean {
    if (weatherStore?.isValid) {
        const defaultLocation = weatherStore.weatherLocations?.[0];
        if (defaultLocation?.multidayForecast?.dailyForecasts) {
            const daysFromToday = differenceInCalendarDays(date, observableToday());
            const daysWithWeather = defaultLocation.multidayForecast.dailyForecasts.length;
            return daysFromToday >= 0 && daysFromToday < daysWithWeather;
        }
    }

    return false;
}
